import OrderPackingComponent from './order_packing.component';
import printBarcodesModule from './print_barcodes';
import printPackedOrdersModule from './print_packed_orders';
import printPackingSlipModule from './print_packing_slip';
import currencyPickReportModule from './currency_pick_report';

let orderPackingModule = angular.module('orderPacking', [
  printBarcodesModule,
  printPackedOrdersModule,
  printPackingSlipModule,
  currencyPickReportModule
])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/order-packing');

    $stateProvider
      .state('orderPacking', {
        url: '/order-packing',
        component: 'orderPacking',
        data: {
          requireLogin: true,
          requireACL: 'order_packing.all'
        },
        parent: 'app',
      });
  })

  .component('orderPacking', OrderPackingComponent)

  .name;

export default orderPackingModule;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/index.js